import React from 'react';
import { Row, Col } from 'antd';
import { I18n } from '@aws-amplify/core';

import { VideoPlayer } from '../VideoPlayer';
import { formatVideoInfoUploadDate } from '@/components/views/Report/KimLhc/utils/helper';
import type { VideoInfo } from '@/context/KimLhc/types';
import * as S from './styles';

interface VideoSectionProps {
	videoInfo?: VideoInfo;
	videoUrl?: string;
}

export function VideoSection({ videoInfo, videoUrl }: Readonly<VideoSectionProps>): JSX.Element {
	const videoInfoUploadDate = formatVideoInfoUploadDate(videoInfo?.upload_date);

	return (
		<Row gutter={[56, 56]}>
			<Col lg={24} xl={12}>
				<S.VideoPlayerWrapper>
					<VideoPlayer src={videoUrl} title={videoInfo?.original_name} />
				</S.VideoPlayerWrapper>
			</Col>
			<Col lg={24} xl={12}>
				<S.VideoInfoCol>
					<S.VideoTitle level={5}>{videoInfo?.original_name}</S.VideoTitle>
					<S.VideoInfoText>
						<S.VideoInfoLabel strong>{I18n.get('Upload date')}: </S.VideoInfoLabel>
						{videoInfoUploadDate}
					</S.VideoInfoText>
					<S.VideoInfoText>
						<S.VideoInfoLabel strong>{I18n.get('Upload author')}: </S.VideoInfoLabel>
						{videoInfo?.upload_author_name}
					</S.VideoInfoText>
				</S.VideoInfoCol>
			</Col>
		</Row>
	);
}
